import { render } from "./HistoriquePrixProduit.vue?vue&type=template&id=3f494d9c&scoped=true&ts=true"
import script from "./HistoriquePrixProduit.vue?vue&type=script&lang=ts"
export * from "./HistoriquePrixProduit.vue?vue&type=script&lang=ts"

import "./HistoriquePrixProduit.vue?vue&type=style&index=0&id=3f494d9c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f494d9c"]])

export default __exports__